import { withSandbox } from 'utils/withSandbox';

import type { Alert } from '@atoms/AlertBanner';
import { AlertBanner } from '@atoms/AlertBanner';

import { sandboxT } from './translations';

const alerts: Alert[] = [
  {
    id: 1,
    alert_message: sandboxT.topBanner.nonProduction
  }
];

const SandboxTopBanner = withSandbox(() => (
  <AlertBanner kind="warning" alerts={alerts} dataTestId="sandbox-top-banner" />
));

export { SandboxTopBanner };
